define(
    'viewmodels/secured/explorer/results/results',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "providers/dataprovider",
        "plugins/router",
        "dropzone",
        "viewmodels/secured/explorer/results/columns"
    ],
    function (ctx, ViewModel, i19n, dataProvider, router, Dropzone, columns) {
        var ctxMenu = null;
        var myDropzone = null;

        var vm = new ViewModel(
        {
            hasCodeBehind: true,
            i19n: i19n,
            touch: kendo.support.mobileOS ? "touch" : "",

            subheading: ko.observable(),
            headingData: ko.observable(),
            
            hasPermission: ko.observable(false),

            actions: {
                supported: !kendo.support.mobileOS,
                download: ko.observable(),
                open: ko.observable(),
                openr: ko.observable(),
                openc: ko.observable(),
                new: ko.observable()                
            },

            resultTitle: ko.observable(),
            resultExtension: ko.observable(),
            resultCount: ko.observable(),
            resultBadgeFilter: { default: { text: ko.observable(), click: filterDefault }, email: { text: ko.observable(), click: filterEmail }, controlled: { text: ko.observable(), click: filterControlled }, working: { text: ko.observable(), click: filterWorking } },

            isGuest: ko.observable(false),
            isInstanceAdmin: ko.observable(false),
            isUploadDocument: ko.observable(false),
            columns: columns,
            copyLinkAddressVisible: ko.observable(true)
        });

        ctx.onNavSearch.subscribe(function (data) {
            init();
            
            vm.headingData(data);
        });
        ctx.onNavFavoriteDocument.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.favouritedocuments) });
        });
        ctx.onNavFavoriteFolder.subscribe(function (folder) {
            init();

            if (!folder) {
                $("#results-grid").hide();

                return;
            }

            $("#addDocuments").disable = false;
            vm.headingData(folder);
            vm.subheading(folder.path());
        });
        ctx.onNavFavoriteSearch.subscribe(function (search) {
            init();

            if (!search) {
                $("#results-grid").hide();

                return;
            }

            $("#addDocuments").disable = false;
            vm.headingData(search);
            vm.subheading(search.path());
        });
        ctx.onNavFlagged.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.flaggeddocuments) });
        });
        ctx.onNavRecent.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.recentdocuments) });
        });
        ctx.onNavMyCheckedOut.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.mycheckedoutdocuments) });
        });
        ctx.onNavAllCheckedOut.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.allcheckedoutdocuments) });
        });
        ctx.onNavFolder.subscribe(function (data) {
            init();

            if (!data || !data.folder) {
                
                $("#results-heading").hide();
                $("#results-filter").hide();
                $("#results-action-bar-search").hide();
                $("#results-grid").hide();

                return;
            }

            var folder = data.folder;

            if (!$("#results-action-bar-search").is(":visible"))
                $("#results-action-bar-search").show();
            if (!$("#results-heading").is(":visible"))
                $("#results-heading").show();
            $("#addDocuments").disable = false;

            vm.headingData(folder);
            vm.subheading('<i class="fa fa-book"></i> ' + ctx.current.library.name + (folder.listId ? '/' + ctx.current.library.list.active.selectedRow().label : ""));
        });
        ctx.onNavFolderShowDeleted.subscribe(function (data) {
            init();
            
            if (!data || !data.folder) {

                $("#results-heading").hide();
                $("#results-filter").hide();
                $("#results-action-bar-search").hide();
                $("#results-grid").hide();

                return;
            }

            var folder = data.folder;

            if (!$("#results-action-bar-search").is(":visible"))
                $("#results-action-bar-search").show();
            if (!$("#results-heading").is(":visible"))
                $("#results-heading").show();
            $("#addDocuments").disable = true;

            vm.headingData(folder);
            vm.subheading('<i class="fa fa-book"></i> ' + ctx.current.library.name + (folder.listId ? '/' + ctx.current.library.list.active.selectedRow().label : ""));
        });
        ctx.onNavMyDeleted.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.mydeleteddocuments) });
        });
        ctx.onNavAllDeleted.subscribe(function (data) {
            init();

            vm.headingData({ name: ko.observable(i19n.to.alldeleteddocuments) });
        });

        //ctx.onDocumentFavorited.subscribe(function (data) {
        //    if (data.isChecked)
        //        documentsService.favouriteDocument(data.document.documentId);
        //    else
        //        documentsService.unfavouriteDocument(data.document.documentId);
        //});
        //ctx.onDocumentFlagged.subscribe(function (data) {
        //    if (data.isChecked)
        //        documentsService.flagDocument(data.document.documentId);
        //    else
        //        documentsService.unflagDocument(data.document.documentId);
        //});

        vm.activate = function () {

            vm.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);
            vm.isInstanceAdmin(vm.session.role == 4 ? true : false);

            fileCount = 0;
        };
        vm.attached = function () {
            vm.resultCount.subscribe(function (n) {
                vm.resultBadgeFilter.default.text(n);                
            });

            vm.resultBadgeFilter.email.text('Email');
            vm.resultBadgeFilter.controlled.text('Controlled');
            vm.resultBadgeFilter.working.text('Working');
            
            $("#results-filter-icon").removeClass("disabled");
            $("#results-filter-icon").addClass("enabled");

            // -FPA-2287
            $("#result-grid-action-bar-download").unbind();
            $("#result-grid-action-bar-download").bind("click", function (e) {
                window.open(vm.actions.download(), "_blank");
            });

            $("#result-grid-action-bar-open-c").unbind();
            $("#result-grid-action-bar-open-c").bind("click", function (e) {
                require(['services/service.runapp'], function (fp) {
                    fp.run($("#protocol-container"), vm.actions.openc());
                });
            });

            $("#result-grid-action-bar-open-r").unbind();
            $("#result-grid-action-bar-open-r").bind("click", function (e) {
                require(['services/service.runapp'], function (fp) {
                    fp.run($("#protocol-container"), vm.actions.openr());
                });
            });

            $("#result-grid-action-bar-new").unbind();
            $("#result-grid-action-bar-new").bind("click", function (e) {
                require(['services/service.runapp'], function (fp) {
                    fp.run($("#protocol-container"), vm.actions.new());
                });
            });

   
            var options = {
                url: "#",
                paramName: "file",
                maxFilesize: vm.config.maxFilesizeUpload,
                accept: function (file, done) {
                    done();
                },
                uploadMultiple: false,
                autoProcessQueue: true,
                parallelUploads: 5,
                method: "PUT",

                init: function () {                   
                    //this.on("dragleave", function (e) {
                    //    if (e.toElement.tagName.toLowerCase() == "form") {
                    //        if (myDropzone.getUploadingFiles().length == 0)
                    //            bindDragDropShowGrid(true);
                            
                    //        return;
                    //    }

                    //    e.preventDefault();
                    //    e.stopPropagation();
                    //});
                    this.on("processing", function (file, done) {
                        dataProvider.signurl
                        .addFile({
                            action: "actionstart",
                            id: ctx.current.folder.folderId,
                            folderId: ctx.current.folder.folderId,
                            title: file.filename,
                            extension: file.fileext,
                        })
                        .done(function (data) {
                            file.fileurl = data.repositoryPutUrl;
                            file.revision = data.revision;
                            file.documentId = data.documentId;

                            done(file);
                        })
                        .fail(function (e) {
                            console.error(e);

                            done(file);
                            myDropzone.cancelUpload(file);
                        });
                    });
                    this.on("addedfile", function (file) {
                        try {
                            var rx = /(?:\.([^.]+))?$/;

                            file.filename = file.name;
                            file.fileext = rx.exec(file.name)[1];

                            if (file.filename !== file.fileext) {
                                file.filename = file.filename.substring(0, file.filename.length - file.fileext.length - 1);
                            }

                        } catch (ex) { }

                        file.fileretry = 0;

                        vm.isUploadDocument(myDropzone.files.length > 0);

                        vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: false });
                    });
                    this.on("removedfile", function (file) {
                        vm.isUploadDocument(myDropzone.files.length > 0);
                    });
                    this.on("sending", function (file, xhr, formData) {
                        xhr.setRequestHeader('content-type', ' ');
                    });
                    this.on("complete", function (file) {
                        //if (myDropzone.getUploadingFiles().length == 0) {
                        //    vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });
                        //}
                    });
                    this.on("error", function (file, response) {
                        if (file.accepted) {
                            file.fileretry++;
                            if (file.fileretry < 4) {
                                setTimeout(function () {
                                    myDropzone.processFile(file);
                                }, 10000 * file.fileretry);
                            }
                        }

                        console.error(response);
                    });
                    this.on("maxfilesexceeded", function () {
                        //vm.notify('error', i19n.to.maxfileexceeded);
                        console.error(i19n.to.maxfileexceeded);
                    });
                    this.on("success", function (file, response) {
                        dataProvider.signurl
                        .addFile({
                            action: "actioncomplete",
                            id: file.documentId,
                        })
                        .done(function (data) {
                            fileCount++;
                            myDropzone.removeFile(file);

                            if (myDropzone.getUploadingFiles().length == 0) {
                                
                                vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });

                                bindDragDropShowGrid(true);

                                ctx.onReloadFolders({ documentId: response.documentId, _updateNode: { docCount: ctx.current.folder.docCount + fileCount, text: ctx.current.folder.name() }, isLoadResults: true });

                                fileCount = 0;
                            }
                        })
                        .fail(function (e) {
                            console.error(e);

                            myDropzone.cancelUpload(file);
                        });
                    });
                    this.on("totaluploadprogress", function (uploadProgress, totalBytes, totalBytesSent) {
                        //console.warn(totalBytesSent + " of " + totalBytes + " (" + uploadProgress + " %)");
                    });
                },
                addRemoveLinks: true,
                dictDefaultMessage: '<span class="bigger-150 bolder">Drop a file</span> to upload \
            	                         <span class="smaller-80 grey">(or click)</span> <br /> \
            	                         <i class="fa fa-cloud-upload blue fa-3x"></i> <br /> \
                                         <span class="smaller-60 grey">Maximum size per file is ' + vm.config.maxFilesizeUpload + 'MB</span>',
                dictResponseError: 'Error while uploading file!',
                previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-details\">\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n    <div class=\"dz-size\" data-dz-size></div>\n    <img data-dz-thumbnail />\n  </div>\n  <div class=\"progress progress-small progress-striped active\"><div class=\"progress-bar progress-bar-info\" data-dz-uploadprogress></div></div>\n  <div class=\"dz-success-mark\"><span></span></div>\n  <div class=\"dz-error-mark\"><span></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n</div>"
            };

            try {

                myDropzone = new Dropzone(".dropzone", options);

            } catch (e) {
                alert('Dropzone.js does not support older browsers!');
            }

            bindDragDropShowGrid(true);
        };

        vm.clickCancelDownload = function () {            
            if (myDropzone) {
                if (myDropzone.getUploadingFiles().length > 0) {
                    location.reload();
                    return;
                }

                myDropzone.removeAllFiles(true);
            }

            bindDragDropShowGrid(true);

            ctx.onReloadFolders({ isLoadResults: true });

            fileCount = 0;

            vm.eventBroker.trigger(vm, vm.config.events.header.show, { isShow: true });

            //$("#results-heading").show();
            //$("#results-action-bar-search").find("#result-filter").show();
            //window.fp.explorerLayout.open("west");
            //window.fp.explorerLayout.open("east");            
        };

        //#region commented
        //vm.actionOpen = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.actions.open();
        //    },
        //    execute: function (complete) {
        //        require(['services/service.runapp'], function (fp) {
        //            complete();
        //            fp.run($("#protocol-container"), vm.actions.open());
        //        });
        //    }
        //});
        //#endregion

        // -FPA-2287
        //vm.actionDownload = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.actions.download();
        //    },
        //    execute: function (complete) {
        //        window.open(vm.actions.download(), "_blank");

        //        complete();
        //    }
        //});
        //vm.actionOpenc = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.actions.openc();
        //    },
        //    execute: function (complete) {
        //        require(['services/service.runapp'], function (fp) {
        //            complete();
        //            fp.run($("#protocol-container"), vm.actions.openc());
        //        });
        //    }
        //});
        //vm.actionOpenr = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.actions.openr();
        //    },
        //    execute: function (complete) {
        //        require(['services/service.runapp'], function (fp) {
        //            complete();
        //            fp.run($("#protocol-container"), vm.actions.openr());
        //        });
        //    }
        //});        
        //vm.actionNew = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting && vm.actions.new();
        //    },
        //    execute: function (complete) {                
        //        require(['services/service.runapp'], function (fp) {
        //            complete();
        //            fp.run($("#protocol-container"), vm.actions.new());
        //        });
        //    }
        //});

        function filterDefault() {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.results.filterby, { type: 'default' });
        }
        function filterEmail() {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.results.filterby, { type: 'email' });
        }
        function filterControlled() {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.results.filterby, { type: 'controlled' });
        }
        function filterWorking() {
            vm.eventBroker.trigger(vm, vm.config.events.explorer.results.filterby, { type: 'working' });
        }

        function init(folderId) {
            vm.headingData(null);
            vm.subheading('');
            vm.resultCount("0");
            $("#addDocuments").disable = true;

            vm.actions.download(null);
            //vm.actions.open(null);
            vm.actions.openr(null);
            vm.actions.openc(null);
            vm.actions.new(null);

            $("#results-dropzone").hide();

            vm.copyLinkAddressVisible(sessionStorage.__url_type == "library" || sessionStorage.__url_type == "library-list");
        }
        function bindDragDropShowGrid(isShow) {
            if (vm.isGuest()) {
                //$("#results-grid").show();
                $("#results-dropzone").hide();

                return;
            }

            if (isShow) {
                $("#results-grid").show();
                $("#results-dropzone").hide();
            } else {
                $("#results-dropzone").show();
                $("#results-grid").hide();                
            }

            //var _grid = $("#explorer-results");
            var _grid = $("#results-grid");

            _grid.off("dragstart", "**");
            _grid.off("dragend", "**");
            _grid.off("dragenter", "**");
            _grid.off("dragleave", "**");
            _grid.off("dragover", "**");
            _grid.off("drop", "**");

            _grid.on("dragstart", function (e) {
                e.preventDefault();
            });
            _grid.on("dragend", function (e) {
                e.preventDefault();
            });
            _grid.on("dragenter", function (e) {                
                e.preventDefault();
                e.stopPropagation();

                if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
                    alert("The file APIs not fully supported in this browser");

                    return false;
                }
                if (!ctx.current.folder || !ctx.current.folder.folderId) {

                    return false;
                }

                _grid.off("dragstart");
                _grid.off("dragend");
                _grid.off("dragenter");
                _grid.off("dragleave");
                _grid.off("dragover");
                _grid.off("drop");

                $("#results-grid").hide();
                $("#results-dropzone").show();

            });
            _grid.on("dragleave", function (e) {
                e.preventDefault();
            });
            _grid.on("dragover", function (e) {
                e.preventDefault();
            });
            _grid.on("drop", function (e) {
                e.preventDefault();
            });


            $("#dropzone-actions").off("dragenter", "**");
            $("#dropzone-actions").on("dragenter", function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
            $("#dropzone-actions").off("dragleave", "**");
            $("#dropzone-actions").on("dragleave", function (e) {

                if (myDropzone.getUploadingFiles().length == 0) {
                    //$("#results-grid").show();
                    //$("#results-dropzone").hide();

                    setTimeout(function () {
                        bindDragDropShowGrid(true);
                    }, 100);
                }

                e.preventDefault();
                e.stopPropagation();
            });
        }

        vm.eventBroker.on(vm, vm.config.events.explorer.results.dropzoneShow, function (data) {
            if (!data.isShow) {
                if (myDropzone.getUploadingFiles().length == 0) {
                    //$("#results-grid").show();
                    //$("#results-dropzone").hide();

                    setTimeout(function () {
                        bindDragDropShowGrid(true);
                    }, 100);
                }
            } else {
                $("#results-dropzone").show();
                $("#results-grid").hide();
            }
        });

        vm.copyLinkAddress = function () {
            copyTextToClipboard(sessionStorage.__url, "Document link copied");
        };

        function copyTextToClipboard(text, msg) {
            var textArea = document.createElement("textarea");

            // Place in top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;
            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            // Avoid flash of white box if rendered for any reason.
            textArea.style.background = 'transparent';
            textArea.style.resize = "none";
            textArea.value = text;
            textArea.style.overflow = "hidden";
            textArea.style.zIndex = "1";

            document.body.appendChild(textArea);

            textArea.select();

            try {
                var successful = document.execCommand('copy');
                //var msg = successful ? 'successful' : 'unsuccessful';
                //console.warn('Copying text command was ' + msg);

                if (successful) {
                    toastr.success(!msg ? "Address link copied." : msg);
                }
            } catch (e) {
                console.error(e);

                toastr.error(e);
            }

            document.body.removeChild(textArea);
        }

        return vm;        
});
